import * as types from './period.actions'
import {NURSING_FACILITIES_NOTIFIED} from "../sample/sample.actions";
import {PERIODS_GRID_FILTER_CHANGED, PERIODS_GRID_SORT_CHANGED, PERIODS_GRID_PAGINATION_CHANGED} from "./period.actions";

const initialState = {
  entities: {
    periods: {},
    facilityStatus: {},
  },
  grid: {
    filterModel: null,
    sortModel: null,
    currentPage: null
  }
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.PERIODS_RECEIVED:
      return {
        ...state,
        fetching: false,
        entities: {
          ...state.entities,
          ...action.payload.entities
        }
      };
    case NURSING_FACILITIES_NOTIFIED:
      return state;

    case PERIODS_GRID_FILTER_CHANGED:
      return {
        ...state,
        grid: {
          ...state.grid,
          filterModel: action.payload.map(x => ({ ...x }))
        }
      };
    
    case PERIODS_GRID_SORT_CHANGED:
    return {
      ...state,
      grid: {
        ...state.grid,
        sortModel: action.payload.map(x => ({ ...x }))
      }
    };

    case PERIODS_GRID_PAGINATION_CHANGED:
    return {
      ...state,
      grid: {
        ...state.grid,
        currentPage: action.payload.currentPage
      }
    };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/periods/period.reducer.js